import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "src/app/base/services/base.service";
import { QrObra } from "../models/qr-obra.model";

@Injectable()
export class QrObrasExportService extends BaseService<QrObra> {

    constructor(public http: HttpClient) {
        super(http);
    }

    public getExportFile(id: number): Observable<Blob> {
        return this.http.get( `${this.baseUrl}/${id}`,
            { responseType: 'blob', headers: this.headers }
        );
    }

    public getPathModule(): string {
        return '/qrobras/exportar';
    }
}